export const dummyNotesData = {
  data: {
    account: {
      ID: 10434,
      AccountID: 282,
      createdBy: "Sophia Leclair",
      noteText:
        "All shipments must include PO number; otherwise AP rejects the invoice.",
      createdAt: "2025-12-19T18:55:44.000Z",
      updatedAt: "2025-12-19T18:56:55.000Z",
    },
    distributor: {
      ID: 10434,
      DistributerID: 45,
      createdBy: "Carlos Ramirez",
      noteText:
        "Distributor should send monthly order summaries to the clinic—this was requested during onboarding.",
      createdAt: "2025-12-23T18:55:44.000Z",
      updatedAt: "2025-12-23T18:56:55.000Z",
    },
  },
};

export const dummyCommentsData = [
  {
    ID: 1,
    createdBy: "James Whitaker",
    createdAt: "2025-12-12T18:55:44.000Z",
    commentText:
      "Let’s reach out to the account owners again soon and remind them when we’re expecting full payment",
  },
  {
    ID: 1,
    createdBy: "Rohan Patel",
    createdAt: "2025-12-08T18:55:44.000Z",
    commentText: "Thanks @Tina Chang! Will flag and get someone on it",
    taggedUser: "Tina Chang",
  },
  {
    ID: 1,
    createdBy: "Tina Chang",
    createdAt: "2025-11-30T18:55:44.000Z",
    commentText: "I also see the discrepancy @Rohan Patel Let’s flag it",
    taggedUser: "Rohan Patel",
  },
  {
    ID: 1,
    createdBy: "Sophia Leclair",
    createdAt: "2025-11-21T18:55:44.000Z",
    commentText:
      "The returned item for product 24J1819-009 has been processed successfully. Just waiting for confirmation but will log when I receive it",
    taggedUser: "Rohan Patel",
  },
  {
    ID: 1,
    createdBy: "Jact Test",
    createdAt: "2025-11-20T18:55:44.000Z",
    commentText:
      "Noticed a discrepancy in the payments applied. Can anyone confirm?",
    taggedUser: "Rohan Patel",
  },
  {
    ID: 1,
    createdBy: "Carlos Ramirez",
    createdAt: "2025-10-16T18:55:44.000Z",
    commentText:
      "Spoke with Dr. Anya Sharma at Biolab Sciences regarding the delay in manufacturing; they anticipate a two-week setback due to equipment maintenance. If anyone from Foot & Ankle Specialists of Central PA reaches out, please ping me so I can...",
    taggedUser: "Rohan Patel",
  },
  {
    ID: 1,
    createdBy: "Tyler Baum",
    createdAt: "2025-09-06T18:55:44.000Z",
    commentText: "@Sophia Loclair Adjusted to the updated argreement.",
    taggedUser: "Sophia Loclair",
  },
  {
    ID: 1,
    createdBy: "Tyler Baum",
    createdAt: "2025-09-06T18:55:44.000Z",
    commentText: "@Sophia Loclair Adjusted to the updated argreement.",
    taggedUser: "Sophia Loclair",
  },
  {
    ID: 1,
    createdBy: "Tyler Baum",
    createdAt: "2025-09-06T18:55:44.000Z",
    commentText: "@Sophia Loclair Adjusted to the updated argreement.",
    taggedUser: "Sophia Loclair",
  },
  {
    ID: 1,
    createdBy: "Tyler Baum",
    createdAt: "2025-09-06T18:55:44.000Z",
    commentText: "@Sophia Loclair Adjusted to the updated argreement.",
    taggedUser: "Sophia Loclair",
  },
  {
    ID: 1,
    createdBy: "Tyler Baum",
    createdAt: "2025-09-06T18:55:44.000Z",
    commentText: "@Sophia Loclair Adjusted to the updated argreement.",
    taggedUser: "Sophia Loclair",
  },
  {
    ID: 1,
    createdBy: "Jact Test",
    createdAt: "2025-17-20T18:55:44.000Z",
    commentText:
      "Noticed a discrepancy in the payments applied. Can anyone confirm?",
    taggedUser: "Rohan Patel",
  },
];
